/**
 * ─── Sentry Alert Configuration (configure in Sentry Dashboard) ───
 *
 * After setting up the Sentry project, create these two alerts:
 *
 * 1. CRITICAL TRANSACTION ALERT
 *    Condition: Any error event where `transaction` contains
 *    'booking' OR 'webhook' OR 'payment'
 *    Action: Notify #eng-alerts Slack channel + PagerDuty
 *
 * 2. ERROR RATE SPIKE ALERT
 *    Condition: Error rate exceeds 5% in any 5-minute window
 *    Action: Notify #eng-alerts Slack channel
 * ──────────────────────────────────────────────────────────────────
 */

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialise Sentry before rendering (lazy to avoid pulling React too early)
const initSentry = async () => {
  if (import.meta.env.VITE_SENTRY_DSN) {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.2,
    });
  }
};

initSentry();

createRoot(document.getElementById("root")!).render(<App />);
